import { metaAccount } from '@/router/meta-config'

export default [
  {
    path: '/info-categories',
    name: 'page-info-categories',
    component: () => import('@/pages/infoCategories'),
    meta: metaAccount
  }
  // {
  //   path: '/info-categories/new',
  //   name: 'page-info-categories-new',
  //   component: () => import('@/pages/infoPage'),
  //   meta: metaAccount
  // },
  // {
  //   path: '/info-page/:id',
  //   name: 'page-info-page',
  //   component: () => import('@/pages/infoPage'),
  //   props: (route) => ({ id: Number(route.params.id) }),
  //   meta: metaAccount
  // }
]
